export default "__VITE_ASSET__5f551d38__"